import styled, { css } from 'styled-components';
import { media } from '@prisjakt/ui-base';

import ThumbUpIcon from 'mdi-react/ThumbUpIcon';

export const PriceRow = styled.li`
  width: 100%;
  line-height: 1.3em;
  position: relative;
  border-bottom: 1px solid ${p => p.theme.lines.primary};

  ${props =>
    props.noExternalUri &&
    css`
      cursor: default;
    `}

  ${props =>
    props.nonFeatured &&
    css`
      color: ${p => p.theme.text.secondary};
      &:hover {
        color: ${p => p.theme.text.secondary};
      }
    `}

  ${media.smallOnly`
      &:last-child {
        border-bottom: 1px solid ${p => p.theme.lines.primary};
      }
    }
  `}
`;

export const ColumnExpanded = styled.div`
  flex: 0 0 100%;
  background-color: rgba(0, 0, 0, 0.03);
  border-top: 1px solid ${p => p.theme.lines.primary};
`;

export const AltPriceRow = styled.a`
  display: block;
  padding-left: 1rem;
  border-top: 1px solid ${p => p.theme.lines.primary};
`;

export const TransparencyShopInfo = styled.div`
  text-align: left;
  margin: 0;
`;

export const ProductName = styled.div`
  display: block;
  -webkit-line-clamp: 2;
  text-overflow: ellipsis;
  overflow: hidden;
  max-height: 3em;
  line-height: 1.5em;
`;

export const ProductNameColumn = styled.div`
  display: flex;
`;

export const RecommendedRetailer = styled.div`
  font-size: 0.8rem;
  white-space: nowrap;
  align-self: normal;
  margin-top: 0.3rem;
  color: ${props => props.theme.text.secondary};
  ${media.smallOnly`
    display: none;
  `};
`;

export const RecommendedRetailerIcon = styled(ThumbUpIcon).attrs({ size: 12 })`
  fill: ${p => p.theme.icons.secondary};
  margin-right: 0.3rem;
`;
